<template>
<div>
    <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
    <PDFViewer :url="src"/>
</div>
</template>

<script>
import PDFViewer from '../../../Common/PDFViewer/PDFViewer';

export default {
    name: 'ContentPDF',
    components: {
        PDFViewer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        src() {
            // Verificar se temos uma URL assinada para visualização no localStorage
            const signedApiUrls = localStorage.getItem(`lesson_${this.$route.params.lessonId}_api_urls`);

            if (signedApiUrls) {
                const apiUrls = JSON.parse(signedApiUrls);
                if (apiUrls && apiUrls.downloads && apiUrls.downloads[this.data.id]) {
                    return `https://docs.google.com/viewer?url=${encodeURIComponent(apiUrls.downloads[this.data.id].show)}&embedded=true`;
                }
            }

            // Se não houver URL assinada, usar a URL normal
            return `https://docs.google.com/viewer?url=${location.origin}/app/files/download/${this.data.id}/${this.data.secret}/show&embedded=true`;
        },
    },
    methods: {
        pdfembed({
            host,
            original_file,
        }, size = 'original') {
            return `https://docs.google.com/viewer?url=${location.origin}/app/files/download/${this.data.id}/${this.data.secret}/show&embedded=true`;
        },
        pdf({
            host,
            original_file,
        }, size = 'original') {
            return `/app/files/show/${this.data.id}/${this.data.secret}`;
        },
    },

};
</script>
